/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_BrowseInputs */

const en_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse Listings`)
};

const es_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar anuncios`)
};

const fr_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir les annonces`)
};

const de_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserate durchsuchen`)
};

const ja_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品を見る`)
};

const zh_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览商品`)
};

const ar_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح الإعلانات`)
};

const id_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi Listing`)
};

const it_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora gli Annunci`)
};

const ru_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор объявлений`)
};

const pt_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar Anúncios`)
};

const ko_footer_link_browse = /** @type {(inputs: Footer_Link_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 둘러보기`)
};

/**
* | output |
* | --- |
* | "Browse Listings" |
*
* @param {Footer_Link_BrowseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_browse = /** @type {((inputs?: Footer_Link_BrowseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_BrowseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_browse(inputs)
	if (locale === "es") return es_footer_link_browse(inputs)
	if (locale === "fr") return fr_footer_link_browse(inputs)
	if (locale === "de") return de_footer_link_browse(inputs)
	if (locale === "ja") return ja_footer_link_browse(inputs)
	if (locale === "zh") return zh_footer_link_browse(inputs)
	if (locale === "ar") return ar_footer_link_browse(inputs)
	if (locale === "id") return id_footer_link_browse(inputs)
	if (locale === "it") return it_footer_link_browse(inputs)
	if (locale === "ru") return ru_footer_link_browse(inputs)
	if (locale === "pt") return pt_footer_link_browse(inputs)
	return ko_footer_link_browse(inputs)
});